import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {
  static targets = ['submitBtn', "form"]
  connect() {
  }

  submitForm(){
    this.submitBtnTarget.click()
    this.modalController.closeModal()
  }

  get modalController() {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'modal';
    });
  }
}
